import LoginComponent from './Auth/LoginPage/LoginComponent';
import IdleTimeout from './Auth/InactiviteLogout.js';
import ChangeFirstPassword from './Auth/ChangeFirstPassword';
import SettingsPage from './Settings';
import HomePage from './Modules/Common/HomePage/HomePageComponent';
import GenericPageNotFound from './Modules/Exception/GenericPageNotFound';

import Profile from '../pages/Settings/Profile/EditProfileContainer';
import ChangePassword from '../pages/Settings/ChangePassword';
import ChangePasswordBulk from '../pages/Settings/ChangePasswordBulk';
import Translation from '../pages/Settings/Translation';
import Preferences from '../pages/Settings/Preferences';
import Organisation from '../pages/Settings/UserManagement/Organisation';
import Site from '../pages/Settings/UserManagement/Site';
import Role from '../pages/Settings/UserManagement/Role';
import Department from '../pages/Settings/UserManagement/Department';
import Users from '../pages/Settings/UserManagement/User';
import MasterView from '../pages/Settings/Masters';
import LandingPage from '../pages/Settings/UserManagement/LandingPage';
import TableConfigurationUpload from '../pages/Settings/TableConfigurationUpload';
import CraneManagement from '../pages/Settings/CraneManagemnet';
import DailyReportUsers from './Settings/DailyReport/DailyReportUsers';
import LookupMasters from '../pages/Settings/Masters/LookupMasters';
import LookupMasterItems from '../pages/Settings/Masters/LookupMasters/LookupMasterItems';
import MenuBuilder from './Settings/MenuBuilder/pages/Homepage';
import MasterConfiguration from '../pages/Settings/Masters/MasterConfiguration';
import ConfigurationBulkUpload from '../pages/Settings/ConfigurationBulkUpload';

import Hierarchy from '../pages/Modules/Hierarchy';
import NestedHierarchy from '../pages/Modules/Hierarchy/NestedHierarchy';
import CronReRun from '../pages/Reports/CronReRun';
import DataBackupConfig from './Modules/DataBackup/Configuration';

import ChatApplication from '../pages/ChatApplication';
import ChatUploadChatApplication from "../pages/ChatApplication/ChatUpload";
import FileuploadChatApplication from "../pages/ChatApplication/ChatUpload/FileUpload.js";

import DefaultLandingPage from '../pages/Modules/Common/DefaultLandingPage';
import TrainStatus from './Modules/Common/DefaultLandingPage/TrainStatus';
import CraneStatus from '../pages/Modules/Common/DefaultLandingPage/CentralDashboard';
import AllModulesList from '../pages/Modules/Common/DefaultLandingPage/AllModulesList';
import EquipmentOverview from '../pages/Modules/Common/DefaultLandingPage/EquipmentOverview';
import CMRLFaults from '../pages/Modules/Common/DefaultLandingPage/CMRL_Faults';

import TopicMaster from './CustomerAssetDeviceConfiguration/TopicMaster';
import TopicList from './CustomerAssetDeviceConfiguration/TopicList';

import Renderer from './3D/Rendering/index.js';
import Hierarchy3D from './3D/Hierarchy/index.jsx';
import DigitalTwinConfiguration from './3D/DigitalTwinConfiguration/index.js';

import Trends from './Trends';
import ViewTrends from './Trends/ViewTrends';
import AnalyticsList from './Analytics/List/index';
// import AnalyticsDetails from './Analytics/Details/PredictionForm';
import TrendsAnalysis from './TrendAnalysis';

import HMI from './HMI/SinglePlot';
import HmiConfiguration from '../pages/HMI/HmiConfiguration';
import ModuleWiseSVG from '../pages/HMI/Custom';
// import HmiEditor from './HMI/HmiEditor';

import DashboardConfiguration from './Dashboard/Configuration';
import ViewDashboard from './Dashboard/DashboardComponents/Dashboard';
import MultilevelDashboard from './Dashboard/Custom/MultiLevelDashboard/index.js';
import EditDashboard from './Dashboard/DashboardComponents/NewDashboard';
import ViewDashboardGroup from './Dashboard/DashboardComponents/ViewDashboardGroup';

import ReportConfiguration from '../pages/Reports/ReportConfiguration';
import Reports from '../pages/Reports';
// import ReportTypeConfiguration from '../pages/Reports/ReportTypeConfiguration';
// import DataWatch from './Reports/DataWatch';
// import ISOReports from './Reports/ISOReports';
import ModuleWiseDashboard from "../pages/HMI/Custom/index.js";
import ELogBookConfiguration from '../pages/ELogBook/Configuration';
import ELogBookView from '../pages/ELogBook/ElogbookView';

import DownTimeLogs from './DownTime';

import RuleEngine from './RuleEngine';
import RulesList from './RuleEngine/rulesList';
import RulesFeedback from './RuleEngine/ruleFeedback';
import RuleEngineRootCause from './RuleEngine/RootCause';
import DeviceTypeRuleExclusion from './RuleEngine/Tabs/DeviceTypeRuleExclusion';
import RuleEngineMaintainance from './RuleEngine/RuleEngineMaintainance';
import AIRulesDetails from '../pages/RuleEngine/AIGenerator';
// import AIFileUpload from './RuleEngine/AIGenerator/FileUpload';
import AIList from '../pages/RuleEngine/AIGenerator/AIList';
import AIFaults from './RuleEngine/AIGenerator/AI_Faults';
import AIFileUpload from '../pages/RuleEngine/AIGenerator/FileUploads/FileUpload';

// import EquipmentMasters from './EMM/EquipmentMastersComponents';
// import EMM from './EMM/EquipmentSelection';

import EAMLandingPage from './AMM/LandingPage';
import AMM from './AMM/Modules';
import Tasks from './AMM/Modules/WorkPlanning/Tasks/TaskList';
import TasksDetails from './AMM/Modules/WorkPlanning/Tasks/TaskForm';
import JobPlanList from './AMM/Modules/WorkPlanning/JobPlan/JobPlanList';
import JobPlanDetails from './AMM/Modules/WorkPlanning/JobPlan/JobPlanForm';
import PMList from './AMM/Modules/WorkPlanning/PM/PMList';
import PMform from './AMM/Modules/WorkPlanning/PM/PMform';
import CMList from './AMM/Modules/WorkPlanning/ConditionalMonitoring/CMList';
import CMDetails from './AMM/Modules/WorkPlanning/ConditionalMonitoring/CmDetails';
import EWODetails from './AMM/Modules/WorkManagement/EmergencyWorkOrders/EmergencyWorkOrderForm';
import EWOList from './AMM/Modules/WorkManagement/EmergencyWorkOrders/EmergencyWorkOrdersList';
import FieldDataMeasurementList from './AMM/Modules/WorkManagement/FieldDataMeasurement/FieldDataMeasurementList';
import FieldDataMeasurementDetails from './AMM/Modules/WorkManagement/FieldDataMeasurement/FieldDataMeasurementDetails';
import ItemList from './AMM/Modules/EquipmentRegister/ItemMaster/ItemList';
import ItemDetails from './AMM/Modules/EquipmentRegister/ItemMaster/ItemDetails';
import MaterialList from './AMM/Modules/EquipmentRegister/MaterialMaster/MaterialList';
import MaterialDetails from './AMM/Modules/EquipmentRegister/MaterialMaster/MaterialDetails';
import ToolsList from './AMM/Modules/EquipmentRegister/ToolsMaster/ToolsList';
import ToolsDetails from './AMM/Modules/EquipmentRegister/ToolsMaster/ToolsDetails';
import InspectionList from './AMM/Modules/WorkManagement/Inspection/InspectionList';
import InspectionDetails from './AMM/Modules/WorkManagement/Inspection/InspectionForm';
import ManPowerList from './AMM/Modules/EquipmentRegister/LaborMaster/ManPowerList';
import ManPowerDetails from './AMM/Modules/EquipmentRegister/LaborMaster/ManPowerDetails';
import WorkFlowList from './AMM/Modules/WorkPlanning/WorkFlow/WorkFlowList';
import WorkFlowDetails from './AMM/Modules/WorkPlanning/WorkFlow/WorkFlowDetails';
import WorkOrderList from './AMM/Modules/WorkManagement/WorkOrders/WorkOrderList';
import WorkOrderDetails from './AMM/Modules/WorkManagement/WorkOrders/WorkOrderDetails';
import WorkOrderTaskDetails from './AMM/Modules/WorkManagement/WorkOrders/WorkOrderTaskDetails';
import FailureCodeList from './AMM/Modules/EquipmentRegister/FailureCodeMaster/FailureCodeList';
import FailureCodeDetails from './AMM/Modules/EquipmentRegister/FailureCodeMaster/FailureCodeDetails';
import EquipmentList from './AMM/Modules/EquipmentRegister/EquipmentMaster/EquipmentList';
import EquipmentDetails from './AMM/Modules/EquipmentRegister/EquipmentMaster/EquipmentDetails';
import SRList from './AMM/Modules/WorkManagement/ServiceRequest/SRList';
import SRDetails from './AMM/Modules/WorkManagement/ServiceRequest/SRDetails';
import InspectionMaster from './AMM/Modules/EquipmentRegister/InspectionMaster';
import InspectionMasterList from './AMM/Modules/EquipmentRegister/InspectionMaster/InspectionMasterList';
import InspectionMasterDetails from './AMM/Modules/EquipmentRegister/InspectionMaster/InspectionMasterDetails';
import EquipmentTagList from './AMM/Modules/EquipmentRegister/EquipmentTagsMaster/EquipmentTagList';
import EquipmentTagDetails from './AMM/Modules/EquipmentRegister/EquipmentTagsMaster/EquipmentTagDetails';
import InventoryList from './AMM/Modules/WorkManagement/Inventory/InventoryList';
import InventoryDetails from './AMM/Modules/WorkManagement/Inventory/InventoryDetails';
import EquipmentOverviewList from './AMM/Modules/WorkManagement/EquipmentOverview/EquipmentOverviewList';
import EquipmentOverviewDetails from './AMM/Modules/WorkManagement/EquipmentOverview/EquipmentOverviewDetails';
import Location from './AMM/Modules/EquipmentRegister/LocationMaster';
import ELogScheduleList from '../pages/AMM/Modules/WorkManagement/ELogbookSchedule/ELogScheduleList';
import ELogScheduleDetails from '../pages/AMM/Modules/WorkManagement/ELogbookSchedule/ELogScheduleDetails';
import CmFeedback from '../pages/AMM/Modules/WorkPlanning/ConditionalMonitoring/CmFeedback';
//import Locations from './AMM/Modules/EquipmentRegister/Locations/AssetDeviceContainer';
import Locations from './AMM/Modules/EquipmentRegister/LocationMaster/index.js';

import FormGenerator from '../pages/FormGenerator';
import FormGeneratorLink from '../pages/FormGenerator/GraphViewComponent';


import WarningDashboard from './Dashboard/ChartComponents/Widgets/Unused/WarningDashboard';
import WarningLimits from './Settings/WarningLimits/index.js';
// import IntervalMasterList from './Modules/Maximo/MaximoIntervalMaster/IntervalMasterList';
// import PageWrapper from './Modules/Common/PageWrapper';
import QueryBuilder from './Modules/Common/QueryBuilder';
import SmartControl from './Modules/Custom/SmartControl';
import SmartControlTags from './Modules/Custom/SmartControlForm';
import XMLConfiguration from './Modules/Custom/XMLConfiguration';
// import XMLConfigurationLists from './Modules/Custom/XMLConfiguration/XMLConfigurationLists';
import MaximoEdgeConfiguration from './Modules/Custom/MaximoEdgeConfiguration';
import FileUploadAndDownload from './Modules/Custom/FileUploadAndDownload';
import MaximoNotification from './Modules/Custom/MaximoEdgeConfiguration/MaximoNotification';
import AssetMapping from './Modules/Custom/AssetMapping';
import QrList from './Modules/Custom/QrCodeScanner/QrList';
import QrDetails from './Modules/Custom/QrCodeScanner/QrDetails';
import MoistureSensor from '../pages/Modules/Custom/MoistureSensor';
import SRHaltTime from '../pages/Modules/Maximo/SRHaltTime';
import SRWaitInterval from '../pages/Modules/Maximo/SRWaitInterval';
import StatusScreen from '../pages/Modules/Maximo/StatusScreen';
import StatusScreenAsset from './Modules/Maximo/StatusScreenAsset.js';
import IntervalMasterDetails from './Modules/Maximo/MaximoIntervalMaster/IntervalMasterDetails';
import InHouseRegistration from '../pages/Modules/Custom/Okumura/InHouseRegistration';

import ModelRegistrations from '../pages/Analytics_Predictions/Version_1.0/List/ModelRegistrations';
import ModelsWorkbench from '../pages/Analytics_Predictions/Version_1.0/List/ModelsWorkbench';
import ModelDetails from '../pages/Analytics_Predictions/Version_1.0/Details/index';
import Model_Comparision from '../pages/Analytics_Predictions/Version_1.1/Model_Comparision';
import BookmarksList from '../pages/Analytics_Predictions/Version_1.1/BookmarksList';
import MonitorDrift from '../pages/Analytics_Predictions/Version_1.1/MonitorDrift';
import DriftCalculationWorkbench from '../pages/Analytics_Predictions/Version_1.1/DriftCalculationWorkbench';
import DataSourceMastersList from '../pages/Analytics_Predictions/Version_1.1/DataSourceMastersList';
import DataSourceMastersDetails from '../pages/Analytics_Predictions/Version_1.1/DataSourceMastersDetails';
import AlgorithmMasterList from './Analytics_Predictions/Version_1.0/Masters/AlgorithmMasterList';
import AlgorithmMasterDetails from './Analytics_Predictions/Version_1.0/Masters/AlgorithmMasterDetails';
import ServerRegistrationList from './Analytics_Predictions/Version_1.0/Masters/ServerRegistrationList';
import ServerRegistrationDetails from './Analytics_Predictions/Version_1.0/Masters/ServerRegistrationDetails';

// import RubusAnalytics from './Analytics/Analytics_V2';
import Analytics_V1 from './Analytics_Predictions/Version_1.0/index.js';
import Analytics_V2 from './Analytics_Predictions/Version_1.1/index.js';
import Home from "../pages/Analytics/Analytics_V2/Home";
import UseCase from "../pages/Analytics/Analytics_V2/UseCase";
import TasksAnalytics from "../pages/Analytics/Analytics_V2/Tasks";
import TrainingJobs from "../pages/Analytics/Analytics_V2/TrainingJobs";
import Analytics from '../pages/Analytics/List';
import AnalyticsDetails from '../pages/Analytics/Details';
// import MonitorDrift from "../pages/Analytics_Predictions/Version_1.1/MonitorDrift";
// import ModelsWorkbench from "../pages/Analytics/Analytics_V1/List/ModelsWorkbench";
// import ModelDetails from "../pages/Analytics_Predictions/Version_1.0/Details/index";
// import BookmarksList from "../pages/Analytics_Predictions/Version_1.1/BookmarksList";
// import Model_Comparision from "../pages/Analytics_Predictions/Version_1.1/Model_Comparision";
// import ModelRegistrations from "../pages/Analytics_Predictions/Version_1.0/List/ModelRegistrations";
// import DataSourceMastersList from "../pages/Analytics_Predictions/Version_1.1/DataSourceMastersList";
// import AlgorithmMasterList from "../pages/Analytics_Predictions/Version_1.0/Masters/AlgorithmMasterList";
// import DataSourceMastersDetails from "../pages/Analytics_Predictions/Version_1.1/DataSourceMastersDetails";
// import DriftCalculationWorkbench from "../pages/Analytics_Predictions/Version_1.1/DriftCalculationWorkbench";
// import AlgorithmMasterDetails from "../pages/Analytics_Predictions/Version_1.0/Masters/AlgorithmMasterDetails";
// import ServerRegistrationList from "../pages/Analytics_Predictions/Version_1.0/Masters/ServerRegistrationList";
// import ServerRegistrationDetails from "../pages/Analytics_Predictions/Version_1.0/Masters/ServerRegistrationDetails";


import CustomHierarchy from './Modules/Custom/Heirarchy/index';
import EditAssetsTree from '../pages/Modules/Custom/Heirarchy/editassetsTree';
import ViewAssetsTree from '../pages/Modules/Custom/Heirarchy/viewassetsTree';

import CustomerAssetDeviceComponent from '../pages/CustomerAssetDeviceConfiguration';
import Mod from '../pages/CustomerAssetDeviceConfiguration/Masters/Mod';
import MasterTemplate from './CustomerAssetDeviceConfiguration/Masters/MasterTemplate.js';
import SubDeviceChildren from '../pages/CustomerAssetDeviceConfiguration/Masters/SubDeviceChildren';
import DeviceTypes from '../pages/CustomerAssetDeviceConfiguration/Masters/DeviceTypes';
import SubEquipments from '../pages/CustomerAssetDeviceConfiguration/Masters/SubEquipments';
import Parameter from '../pages/CustomerAssetDeviceConfiguration/Masters/Parameter';
import Attributes from '../pages/CustomerAssetDeviceConfiguration/Masters/Attributes';
import DeviceTypesChildren from '../pages/CustomerAssetDeviceConfiguration/Masters/DeviceTypesChildren';
import StatusConfiguration from '../pages/CustomerAssetDeviceConfiguration/StatusConfiguration';
import AssetAttributes from '../pages/CustomerAssetDeviceConfiguration/Masters/RubusMaster/AssetAttributes';
import AssetTypes from '../pages/CustomerAssetDeviceConfiguration/Masters/RubusMaster/AssetTypes';
import DynamicHierarchy from '../pages/CustomerAssetDeviceConfiguration/Masters/RubusMaster/DynamicHierarchy';
import AssetAttributeList from '../pages/CustomerAssetDeviceConfiguration/AssetAttributes/AssetAttributeList';
import AssetParameter from '../pages/CustomerAssetDeviceConfiguration/Masters/AssetParameter';
import AssetType from '../pages/CustomerAssetDeviceConfiguration/Masters/AssetType';
import TaskScheduler from './Modules/DataBackup/TaskScheduler';
import TaskSchedulerDetails from './Modules/DataBackup/TaskSchedulerDetails';
import PurgeList from './Modules/DataBackup/Purge';
import DailyPowerGenerationReport from '../pages/Reports/Custom/DailyPowerGenerationReport';
import Measurement from '../pages/Modules/Custom/MoistureSensor/form/Measurement.js';
//import MultilevelDashboard from '../pages/Dashboard/Custom/MultiLevelDashboard';
import FailureReports from './FRACAS/FRACAS_V1/FailureReports';
import FailureReportsMultiple from './FRACAS/FRACAS_V2/FailureReportsMultiple';
import QuestionsList from './FRACAS/QuestionsList';
import QuestionsDetails from './FRACAS/QuestionsDetails';
import FracasPermissions from './Settings/FRACASPermissions';
import ParameterAlias from './CustomerAssetDeviceConfiguration/Masters/RubusMaster/ParameterAlias.js';
import ColorCodes from './CustomerAssetDeviceConfiguration/Masters/RubusMaster/ColorCodes.js';
import ParameterMapping from './Modules/Custom/ParameterMapping/index.js';
import DataAlerts from './Modules/Custom/DataAlerts/index.js';
export {
  LoginComponent,
  IdleTimeout,
  ChangeFirstPassword,
  HomePage,
  SettingsPage,
  GenericPageNotFound,
  Measurement,
  Profile,
  ChangePassword,
  ChangePasswordBulk,
  Preferences,
  Translation,
  ParameterMapping,
  MasterConfiguration,
  MenuBuilder,
  MasterView,
  Organisation,
  Site,
  ModuleWiseDashboard,
  Role,
  Users,
  Department,
  LandingPage,
  CraneManagement,
  DailyReportUsers,
  TableConfigurationUpload,
  LookupMasters,
  LookupMasterItems,
  ConfigurationBulkUpload,
  MasterTemplate,
  Hierarchy,
  NestedHierarchy,
  CronReRun,
  DataBackupConfig,

  CustomHierarchy,
  EditAssetsTree,
  ViewAssetsTree,

  ChatApplication,
  ChatUploadChatApplication,
  FileuploadChatApplication,

  DefaultLandingPage,
  TrainStatus,
  CraneStatus,
  AllModulesList,
  //EquipmentOverview,
  CMRLFaults,

  TaskScheduler,
  TaskSchedulerDetails,
  PurgeList,
  // Configuration,
  DailyPowerGenerationReport,
  Analytics_V1,
  Analytics_V2,
  Home,
  UseCase,
  TasksAnalytics,
  TrainingJobs,
  // PageWrapper,
  // CraneStatus,
  // TrainStatus,
  // GenericPageNotFound,
  XMLConfiguration,
  // XMLConfigurationLists,
  MaximoEdgeConfiguration,
  FileUploadAndDownload,
  MaximoNotification,
  AssetType,

  Renderer,
  DigitalTwinConfiguration,
  Hierarchy3D,

  CmFeedback,
  TopicMaster,
  TopicList,
  Trends,
  ViewTrends,
  TrendsAnalysis,
  HMI,
  // HmiEditor,
  HmiConfiguration,
  ModuleWiseSVG,
  DashboardConfiguration,
  ViewDashboard,
  MultilevelDashboard,
  EditDashboard,
  ViewDashboardGroup,
  // ReportTypeConfiguration,
  ReportConfiguration,
  Reports,
  // DataWatch,
  // ISOReports,
  ELogBookConfiguration,
  ELogBookView,
  DownTimeLogs,
  RulesList,
  RuleEngine,
  RulesFeedback,
  RuleEngineRootCause,
  DeviceTypeRuleExclusion,
  RuleEngineMaintainance,
  AIRulesDetails,
  AIFileUpload,
  AIList,
  AIFaults,
  // AIFileUploads,
  // EquipmentMasters,
  // EMM,
  // AMMAssetDeviceList,
  AMM,
  Tasks,
  TasksDetails,
  JobPlanList,
  JobPlanDetails,
  PMList,
  PMform,
  CMList,
  CMDetails,
  EWOList,
  EWODetails,
  FieldDataMeasurementList,
  FieldDataMeasurementDetails,
  ItemList,
  ItemDetails,
  MaterialList,
  MaterialDetails,
  InspectionList,
  InspectionDetails,
  ToolsList,
  ToolsDetails,
  WorkFlowList,
  WorkFlowDetails,
  ManPowerList,
  ManPowerDetails,
  WorkOrderList,
  WorkOrderDetails,
  WorkOrderTaskDetails,
  SubDeviceChildren,
  FailureCodeDetails,
  FailureCodeList,
  EquipmentTagList,
  EquipmentTagDetails,
  SRList,
  SRDetails,
  InspectionMaster,
  InspectionMasterList,
  InspectionMasterDetails,
  EquipmentList,
  EquipmentDetails,
  InventoryList,
  InventoryDetails,
  EAMLandingPage,
  Analytics,
  AnalyticsList,
  AnalyticsDetails,
  ModelRegistrations,
  ModelsWorkbench,
  ModelDetails,
  Model_Comparision,
  BookmarksList,
  MonitorDrift,
  DataSourceMastersList,
  AlgorithmMasterList,
  DataSourceMastersDetails,
  DriftCalculationWorkbench,
  AlgorithmMasterDetails,
  ServerRegistrationDetails,
  ServerRegistrationList,
  //RubusAnalytics,
  //MmmoclLandingPage,
  QueryBuilder,
  AssetMapping,
  SmartControl,
  QrList,
  QrDetails,
  SmartControlTags,
  MoistureSensor,
  EquipmentOverviewList,
  EquipmentOverviewDetails,
  Locations,
  Location,
  ELogScheduleList,
  ELogScheduleDetails,
  FormGenerator,
  FormGeneratorLink,
  //AllModulesList,
  EquipmentOverview,
  SRHaltTime,
  SRWaitInterval,
  StatusScreen,
  StatusScreenAsset,
  IntervalMasterDetails,
  // IntervalMasterList,
  InHouseRegistration,
  //   DriftCalculationWorkbench,
  //   DataSourceMastersList,
  //   DataSourceMastersDetails,
  CustomerAssetDeviceComponent,
  Mod,
  DeviceTypes,
  SubEquipments,
  StatusConfiguration,
  AssetAttributes,
  AssetTypes,
  DynamicHierarchy,
  Parameter,
  Attributes,
  DeviceTypesChildren,
  //   AlgorithmMasterList,
  //   AlgorithmMasterDetails,
  //   ServerRegistrationList,
  //   ServerRegistrationDetails
  AssetAttributeList,
  AssetParameter,
  // MultilevelDashboard,
  WarningDashboard,
  WarningLimits,
  FailureReports,
  FailureReportsMultiple,
  QuestionsList,
  QuestionsDetails,
  FracasPermissions,
  ParameterAlias,
  ColorCodes,
  DataAlerts
};
